import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter, map } from 'rxjs/operators';
import { WebConfigurationService } from './services/http/common/web-configuration.service';
import { UserService } from './services/http/user/user.service';

/** Constants to handle translations */
export const ABSOLUTE_LANGUAGE_FALLBACK: string = 'fr/default';
export const JSON_EXTENSION: string = '.json';
export const I18N_PATH: string = './assets/i18n/';
export const DEFAULT: string = 'default';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  
  public appTitle: string = 'gmao-ui';
  public logged : boolean = false;

  public constructor(private translate: TranslateService, private titleService: Title, private router: Router, private activatedRoute: ActivatedRoute, private userService: UserService) {

    this.translate.setDefaultLang( ABSOLUTE_LANGUAGE_FALLBACK );
    
    var userLang = navigator.language;     
    // console.log('Browser language : ' + userLang);
    var rootLng = userLang.substring(0,2);

    this.tryToLoad(rootLng, userLang);
  }
  
  ngOnInit() {
    this.appTitle = this.titleService.getTitle();
    this.router
      .events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          const child = this.activatedRoute.firstChild;
          if (child!.snapshot.data['title']) {
            return child!.snapshot.data['title'];
          }
          return this.appTitle;
        })
      ).subscribe((ttl: string) => {
        this.titleService.setTitle(ttl);
      });
     /** Upon app launch, user is not logged-in */
     this.userService.notLoggedYet();
  } 

  tryToLoad(rootLng: string, languageToFind: string) {
      let loadThis = rootLng + '/' + languageToFind;
      if( languageToFind == ''){
        loadThis = rootLng;
      }
      // console.log('Looking for : ' + loadThis);
      this.translate.use( loadThis ).subscribe(
          () => {/*console.log('LOADED : ', loadThis);*/},
          () => {
            // console.log('NOT FOUND : ', loadThis);
            if( languageToFind != '' && languageToFind != DEFAULT){
              // console.log('TRYING : ', rootLng + '/' + DEFAULT);              
              this.tryToLoad(rootLng, DEFAULT);
            } else {
              // console.log('LOADING : ABSOLUTE_FALLBACK : ' + ABSOLUTE_LANGUAGE_FALLBACK);
              this.tryToLoad(ABSOLUTE_LANGUAGE_FALLBACK, '');
            }
          }
        );   
  }

  /* Check if there is already a token in the local storage, when user refresh the page */
  hasToken() : boolean {
    let strToken = localStorage.getItem('userToken');
    if ( strToken ) { 
      WebConfigurationService.bearerToken = JSON.parse(strToken);
      this.logged = true;
    } else {
      this.logged = false;
    }

    return this.logged;
  }


}
